var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mt-2 headline text-center",attrs:{"prominent":"","type":"success"}},[_vm._v(" "+_vm._s(_vm.$t('multiproject.projectFinished.message'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }